import BaseDialog from '@/components/ui/BaseDialog';
import { Box } from '@mui/material';
import CaptchaCanvas from '@/components/form/CaptchaCanvas';
import { Trans, useTranslation } from 'react-i18next';

interface DeleteClusterDialogProps {
    clusterName: string;
    isDialogOpen: boolean;
    onConfirmDelete: () => void;
    onClose: () => void;
    captchaKey: string;
    isCaptchaError: boolean;
    setCaptcha: (captcha: string) => void;
}

export default function DeleteClusterDialog({
    clusterName,
    isDialogOpen,
    onConfirmDelete,
    onClose,
    captchaKey,
    isCaptchaError,
    setCaptcha,
}: DeleteClusterDialogProps) {
    const { t } = useTranslation('common');
    return (
        <BaseDialog
            dialogTitle={t('Delete Cluster')}
            open={isDialogOpen}
            confirmButtonText={t('Confirm')}
            cancelButtonText={t('Cancel')}
            onConfirm={onConfirmDelete}
            onClose={onClose}
        >
            <Box>
                <Box>
                    <Trans
                        i18nKey="Please ensure the cluster <b>{{name}}</b> is cleared before deletion."
                        ns="common"
                        values={{ name: clusterName }}
                        components={{ b: <b /> }}
                    />
                </Box>
                <CaptchaCanvas captchaKey={captchaKey} isCaptchaError={isCaptchaError} setCaptcha={setCaptcha} />
            </Box>
        </BaseDialog>
    );
}
